import { StrictMode } from 'react';

import { ThemeProvider } from 'pixel-react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { store } from './store';

declare global {
  interface Window {
    shouldShowLoader?: boolean;
  }
}
const rootElement = document.getElementById('root');

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2026-01-30',
} as const;

const isLocalhost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname === '';

const isOnprem = import.meta.env.VITE_ENVIRONMENT === 'onprem';
const enablePosthog = import.meta.env.VITE_ENABLE_POSTHOG === 'true';
if (!isLocalhost && !isOnprem && enablePosthog) {
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    autocapture: true,
    capture_pageview: true,
    capture_performance: true,
    loaded: ph => ph.debug(),
  });
} else {
  console.log('PostHog tracking disabled for local development.');
}
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <HelmetProvider>
        <ThemeProvider>
          <Provider store={store}>
            <BrowserRouter>
              <PostHogProvider client={posthog}>
                <App />
              </PostHogProvider>
            </BrowserRouter>
          </Provider>
        </ThemeProvider>
      </HelmetProvider>
    </StrictMode>,
  );
  if (window.shouldShowLoader) {
    setTimeout(() => {
      const loader = document.getElementById('loader');
      if (loader) {
        loader.classList.add('hidden');
        loader.remove();
      }
    }, 3600);
  }
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/sw.js')
    .then(registration => {
      console.log(
        'Service Worker registered successfully....',
        registration.scope,
      );
    })
    .catch(error => {
      console.error('Service Worker registration failed:', error);
    });
}
